import * as React from 'react';
import PropTypes from 'prop-types';
import { StaticImage } from 'gatsby-plugin-image';
import UAParser from 'ua-parser-js';

import Button from '../Button';

import './style.scss';

const checkUALabel = ua => {
  const parser = new UAParser();
  const result = parser.getResult();
  return result.os.name === ua;
};

const CTABanner = props => {
  return (
    <div className="cta-banner">
      <div className="container">
        <div
          className="content"
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <h2 className="title">Read more in the Councils' 2021/22 Annual Report</h2>
          <div>
            <Button
              color="tertiary"
              annualReportPage={props.annualReportPage}
              label={checkUALabel('Android') ? 'Download' : 'Read more'}
              srLabelContinuation="in our annual report"
              icon="link"
              openInNewTab
              onClick={() => window.gtag('event', 'Read more - annual report ')}
            />
          </div>
        </div>
        <div className="cover">
          {props.cover ? (
            props.cover
          ) : (
            <StaticImage
              src="./assets/cover.jpg"
              alt="Cover of Professional Standards Councils' 2021/22 Annual Report"
              width={460}
            />
          )}
        </div>
      </div>
    </div>
  );
};

CTABanner.propTypes = {
  annualReportPage: PropTypes.number,
};

export default CTABanner;
